import Grid from "@mui/material/Grid";
import React, { useMemo } from "react";

import { renderPath } from "../utils/archiverUtils";
import { HeightAdjustedTextField, StyledCardContent } from "../utils/StyledComponents";

import CandidateActions from "./CandidateActions";

export default function MovieCandidate({
  lightBackground,
  candidate,
  candidateRoot,
  actionTypes,
  onActionIconClick,
  onCandidateTextFieldChange,
}) {
  const showActions = useMemo(
    () => candidateRoot.archiveActionType === null,
    [candidateRoot.archiveActionType],
  );

  return (
    <StyledCardContent isEven={lightBackground}>
      <Grid container spacing={2} alignItems="center">
        {renderPath(candidate, candidateRoot)}
        <Grid size={{ xs: 12, md: 4 }}>
          {showActions ? (
            <CandidateActions
              candidate={candidate}
              actionTypes={actionTypes}
              onActionIconClick={onActionIconClick}
            />
          ) : null}
        </Grid>
      </Grid>

      <Grid container spacing={2} justifyContent="space-between">
        <Grid size={12}>
          <HeightAdjustedTextField
            value={candidate.name}
            onChange={onCandidateTextFieldChange}
            id="name"
            name={candidate.path}
            label="Title"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </StyledCardContent>
  );
}
